import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/DashboardShell";
import { PrimaryButton } from "@/components/brand";
import api from "@/lib/api";

export default function AdminRegions() {
  const [regions, setRegions] = useState([]);
  const [form, setForm] = useState({ code: "", name: "" });

  const load = useCallback(async () => {
    const { data } = await api.get("/regions");
    setRegions(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (r) => {
    try { await api.patch(`/regions/${r.id}`, { active: !r.active }); load(); }
    catch { toast.error("Failed"); }
  };
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/regions", { code: form.code, name: form.name, active: true }); setForm({ code: "", name: "" }); toast.success("Region added"); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };

  return (
    <div>
      <PageHeader index="05" eyebrow="Regions" title="Region coverage" tag={`${regions.filter((r) => r.active).length}/${regions.length} active`} />

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-px bg-gray-200 border border-gray-200" data-testid="region-grid">
          {regions.map((r) => (
            <div key={r.id} className="bg-white p-4 flex items-center justify-between" data-testid={`region-${r.code}`}>
              <div>
                <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400">{r.code}</div>
                <div className="text-sm text-[#0a0a0a] mt-0.5">{r.name}</div>
              </div>
              <button onClick={() => toggle(r)} data-testid={`toggle-region-${r.code}`}
                className={`font-mono text-[10px] tracking-[0.1em] uppercase px-2.5 py-1 border ${r.active ? "bg-[#0a0a0a] text-white border-[#0a0a0a]" : "border-gray-300 text-gray-400"}`}>
                {r.active ? "Active" : "Off"}
              </button>
            </div>
          ))}
        </div>

        <form onSubmit={add} className="border border-gray-200 p-6 space-y-5 h-fit" data-testid="add-region-form">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400">Add region</div>
          <div><label className="routa-label">Code</label><input data-testid="region-code" required value={form.code} onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))} className="routa-input" placeholder="e.g. BAR-14" /></div>
          <div><label className="routa-label">Name</label><input data-testid="region-name" required value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="routa-input" /></div>
          <PrimaryButton type="submit" data-testid="region-add-submit">Add region</PrimaryButton>
        </form>
      </div>
    </div>
  );
}
